import React from "react";
import { useSearchParams } from "react-router-dom";
import EditDocComponent from "./SyncButton";

const VersionDiffViewer = () => {
  const [searchParams] = useSearchParams();
  const fileUrl = searchParams.get("file");

  if (!fileUrl) {
    return <div>No document to preview.</div>;
  }

  return (
    <div style={{ height: "100vh" }}>
      <EditDocComponent
        fileUrl={fileUrl}
        userName="Admin"
        isEditable={false}
        hasBeenShown={false}
        onClose={() => {}}
      />
    </div>
  );
};

export default VersionDiffViewer;
